import React from 'react'
import { TuvSeal } from '../icons/TuvSeal'
import { useResponsive } from '../../hooks'
import './TUVSealSection.scss'

export const TuvSealSection = () => {
  const { isMobile } = useResponsive()
  return (
    <div className={isMobile ? 'tuv-seal-footer' : 'tuv-seal-sidebar'}>
      <h6>Unser Service ist zertifiziert</h6>
      <TuvSeal data-test-id='tuv-seal' />
    </div>
  )
}
